@if (!open()) {
  <!-- Collapsed pill — draggable in its own right (not just a shrunk copy
       of the card), per the explicit ask that even the minimised state can
       be moved out of the way of whatever's underneath it. -->
  <button
    type="button"
    class="nv-dock-pill"
    cdkDrag
    cdkDragBoundary="body"
    [cdkDragFreeDragPosition]="pillPosition()"
    (pointerdown)="onPillPointerDown()"
    (cdkDragStarted)="onPillDragStarted()"
    (cdkDragEnded)="onPillDragEnded($event)"
    (click)="onPillClick()"
  >
    @if (totalCount() > 0) {
      <span class="nv-dock-pill__dot" aria-hidden="true"></span>
    }
    <nv-icon [size]="18">notifications</nv-icon>
    @if (totalCount() > 0) {
      <span>{{ totalCount() }} {{ totalCount() === 1 ? 'item needs' : 'items need' }} attention</span>
    } @else {
      <span>Attention</span>
    }
  </button>
} @else {
  <div
    class="nv-dock"
    cdkDrag
    cdkDragBoundary="body"
    [cdkDragFreeDragPosition]="cardPosition()"
    (cdkDragStarted)="onCardDragStarted()"
    (cdkDragEnded)="onCardDragEnded($event)"
    [style.top.px]="topPx()"
    [style.height.px]="heightPx()"
  >
    <header class="nv-dock__head" cdkDragHandle (pointerdown)="onCardHeaderPointerDown()">
      <nv-icon [size]="16" class="nv-dock__grip" aria-hidden="true">drag_indicator</nv-icon>
      @if (totalCount() > 0) {
        <span class="nv-dock__dot" aria-hidden="true"></span>
      }
      <!-- Item 27 — the "N waiting · N orders · N tasks" subtitle is gone:
           the tab bar below already carries a per-tab count badge and an
           alert dot, so the line only repeated it in a second place. -->
      <div class="nv-dock__titles">
        <span class="nv-dock__title">Attention</span>
      </div>

      @if (audioBlocked()) {
        <button type="button" nvButton="text" size="xs" class="nv-dock__sound" (click)="onSoundClick()">
          <nv-icon [size]="16">volume_up</nv-icon>
          Turn on sound
        </button>
      }

      <button type="button" nvButton="icon" size="xs" aria-label="Minimise" (click)="onMinimiseClick()">
        <nv-icon [size]="18">expand_more</nv-icon>
      </button>
    </header>

    <nv-tab-bar class="nv-dock__tabs" [tabs]="tabs()" [value]="activeTab()" (valueChange)="setTab($event)" ariaLabel="Requests and tasks" />

    <div class="nv-dock__body nvx-scroll">
      <div [hidden]="activeTab() !== 'requests'">
        <nv-request-alerts />
      </div>
      @if (showTasksTab()) {
        <div [hidden]="activeTab() !== 'orders'">
          <nv-order-approval-strip />
        </div>
      }
      <div [hidden]="activeTab() !== 'tasks'">
        @if (pendingTasks().length === 0) {
          <div class="nv-dock-tasks__empty">
            <p class="nv-dock-tasks__empty-title">Nothing waiting</p>
            <p class="nv-dock-tasks__empty-note">No task is waiting to be picked up.</p>
          </div>
        } @else {
          <ul class="nv-dock-tasks">
            @for (task of pendingTasks(); track task.id) {
              <li class="nv-dock-tasks__row">
                <div class="nv-dock-tasks__text">
                  <span class="nv-dock-tasks__title">{{ task.title }}</span>
                  <span class="nv-dock-tasks__meta">Due {{ taskDue(task) }} · {{ task.priority }}</span>
                </div>
                <a nvButton="primary" size="xs" routerLink="/tasks">Open</a>
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <div
      class="nv-dock__resize"
      role="separator"
      aria-orientation="horizontal"
      aria-label="Resize"
      (pointerdown)="startResize($event)"
    >
      <span class="nv-dock__resize-handle" aria-hidden="true"></span>
    </div>
  </div>
}
